import { useEffect, useState } from "react";
import { store } from "../store";

export function usePersistHydrated() {
  const [hydrated, setHydrated] = useState(
    () => store.persist?.hasHydrated?.() ?? true,
  );

  useEffect(() => {
    const persist = store.persist;
    if (!persist?.onFinishHydration) return undefined;

    let cancelled = false;
    const mark = () => {
      if (!cancelled) setHydrated(true);
    };

    const unsub = persist.onFinishHydration(mark);
    if (persist.hasHydrated()) queueMicrotask(mark);

    return () => {
      cancelled = true;
      unsub();
    };
  }, []);

  return hydrated;
}
